import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useAddAdvertisementMutation } from "../../../services/advertisement/updateAdvertisementSlice";

import { FormInput } from "../../../component/shared/formElements/formInput/FormInput";
import { FormImagePreviewAndUpload } from "../../../component/shared/formElements/FormImagePreviewAndUpload/FormImagePreviewAndUpload";
import { FormCheckboxChips } from "../../../component/shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { FormDropdown } from "../../../component/shared/formElements/formDropdown/FormDropdown";

import {
  moduleArray,
  pageArray,
} from "../advertisementFilter/AdvertisementFilterPage";

import classes from "./createAdvertisementPage.module.css";

export const CreateAdvertisementPage = () => {
  const navigate = useNavigate();
  const [addAdvertisement, { isLoading }] = useAddAdvertisementMutation();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      sequence: "",
      navigate_to_page: "",
      tag: "",
      params: "",
      alt: "",
      media_type: "",
      category: "",
      page: "",
      url: "",
      url_2: "",
    },
    mode: "onChange",
  });

  const smallImage = watch("url");
  const largeImage = watch("url_2");

  const onSubmit = async (data) => {
    try {
      const response = await addAdvertisement(data).unwrap();
      toast.success(
        response.message.displayMessage || "Advertisement added successfully"
      );
      navigate("/advertisement");
    } catch (err) {
      toast.error("Failed to add advertisement");
    }
  };

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>Add Advertisement</h2>

      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        {/* -------- BASIC INFO -------- */}
        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Advertisement Information</h3>

          <div className={classes.grid}>
            <FormInput id="sequence" label="Sequence" register={register} />
            <FormInput
              id="navigate_to_page"
              label="Navigate To Page"
              register={register}
            />
            <FormInput id="tag" label="Tag" register={register} />
            <FormInput id="params" label="Params" register={register} />

            <FormInput
              id="alt"
              label="Alt Text"
              register={register}
              validation={{ required: "Alt text is required" }}
              error={errors.alt?.message}
              required
            />

            <FormCheckboxChips
              id="media_type"
              label="Media Type"
              options={[
                { id: "image", label: "Image" },
                { id: "video", label: "Video" },
              ]}
              watch={watch}
              setValue={setValue}
              register={register}
              validation={{ required: "Media type is required" }}
              error={errors.media_type?.message}
            />

            <FormDropdown
              id="category"
              label="Module"
              options={moduleArray}
              watch={watch}
              setValue={setValue}
              register={register}
              validation={{ required: "Category is required" }}
              error={errors.category?.message}
              required
            />

            <FormDropdown
              id="page"
              label="Page"
              options={pageArray}
              watch={watch}
              setValue={setValue}
              register={register}
              validation={{ required: "Page is required" }}
              error={errors.page?.message}
              required
            />
          </div>
        </div>

        {/* -------- IMAGES -------- */}
        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Small Screen Image</h3>
          <FormImagePreviewAndUpload
            id="url"
            url={smallImage}
            register={register}
            setValue={setValue}
            validation={{ required: "Small image is required" }}
            error={errors.url?.message}
          />
        </div>

        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Large Screen Image</h3>
          <FormImagePreviewAndUpload
            id="url_2"
            url={largeImage}
            register={register}
            setValue={setValue}
            validation={{ required: "Large image is required" }}
            error={errors.url_2?.message}
          />
        </div>

        {/* -------- ACTIONS -------- */}
        <div className={classes.actions}>
          <button
            type="submit"
            className={classes.submitBtn}
            disabled={!isValid || isLoading}
          >
            {isLoading ? "Adding..." : "Add Advertisement"}
          </button>
        </div>
      </form>
    </div>
  );
};
